module.exports = __webpack_public_path__ + "static/media/pic01.c2b22a46.gif";